import { jsxs } from "react/jsx-runtime";
const Label = (props) => {
  const {
    prefix = "",
    label = "Label",
    reqText,
    htmlFor,
    className,
    ...otherProps
  } = props;
  return /* @__PURE__ */ jsxs("label", { htmlFor, className, ...otherProps, children: [
    label,
    reqText && /* @__PURE__ */ jsxs("em", { className: `${prefix}required`, children: [
      " ",
      reqText
    ] })
  ] });
};
var Label_default = Label;
export {
  Label_default as default
};
